import { motion } from 'framer-motion';
import {
  FaGraduationCap,
  FaHeart,
  FaPuzzlePiece,
  FaUserTie,
  FaSchool,
  FaLightbulb
} from 'react-icons/fa';

const features = [
  {
    Icon: FaGraduationCap,
    title: 'Innovative Early Years Curriculum',
    description:
      'Tailored for Pre-Primary & Grades 1–5, blending play‑based learning with foundational academics.',
  },
  {
    Icon: FaHeart,
    title: 'Values‑Centered Education',
    description:
      'We cultivate empathy, integrity, and community from the very first day.',
  },
  {
    Icon: FaPuzzlePiece,
    title: 'Holistic Development',
    description:
      'Creative arts, sports, and mindfulness integrated to support every aspect of growth.',
  },
  {
    Icon: FaUserTie,
    title: 'Dedicated Educators',
    description:
      'Our young, passionate faculty bring energy and innovation to every classroom.',
  },
  {
    Icon: FaSchool,
    title: 'Safe & Nurturing Campus',
    description:
      'Thoughtfully designed spaces where discovery, collaboration, and play thrive.',
  },
  {
    Icon: FaLightbulb,
    title: 'Personalized Support',
    description:
      'Small class sizes and individualized attention ensure each child excels.',
  },
];

export default function WhyUsPage() {
  return (
    <section className="bg-white text-gray-900 py-20 px-6 md:px-20">
      {/* Hero */}
      <motion.section
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="text-center max-w-3xl mx-auto mb-16"
      >
        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-schoolRed text-rl">Why Choose Springdales?</h1>
        <p className="text-lg text-gray-700">
          Founded in 2019, we specialize in nurturing young minds through a focused, joyful learning journey up to Grade 5.
        </p>
      </motion.section>

      {/* Features Grid */}
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {features.map(({ Icon, title, description }, idx) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="h-full bg-white rounded-xl shadow-lg hover:shadow-2xl transition-shadow">
              <div className="p-6 flex flex-col items-center">
                <Icon className="w-8 h-8 text-schoolRed mb-4" />
                <h3 className="text-xl font-semibold mb-2 text-schoolBlue">{title}</h3>
                <p className="text-gray-600 flex-1">{description}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* CTA */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="text-center mt-16"
      >
        <a
          href="/contact"
          className="inline-block px-8 py-3 bg-[#0077CC] text-white font-semibold rounded-full shadow-lg hover:bg-[#0196ad] transition-colors"
        >
          Enroll Now
        </a>
      </motion.div>
    </section>
  );
}
